import React from "react";
import { Link } from "react-router-dom";
import "./recipie.css";

const Recipie = (props) => {
  return (
    <Link to={`/recipes/${props.RecipieLink}`} className="removeLinkDecoration">
      <div className="recipieCard">
        <img src={props.IMG} alt="Recipie Img" />
        <div className="recipieName">{props.RecipieName}</div>
      </div>
    </Link>
  );
};

export default Recipie;
